<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'DetailProduk',

    metaInfo: { title: 'Detail Produk' },

    extends: View,

    mixins: [
      LoadSections([
        'products-detail-cob',
        'products',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'productsdetail',
      },
    },
  }
</script>
